import BaseConfig from "./BaseConfig";

export default class RequestUser extends BaseConfig {
  transformToAddress(address = []) {
    return [...address, this.config.defaultSupportEmail];
  }

  getCopyReciepients() {
    return this.config.defaultSupportEmail;
  }
}
